const debug = (message) => {
  // Todo: add logging service
  if (process.env.CONSOLE_LOGGING === true) {
    console.log(message);
  }
};

export default debug;
